// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { PartitionKeyDefinition } from "./PartitionKeyDefinition";

export type PartitionKey = PartitionKeyDefinition | string | number | unknown;
